import { useContext, useEffect } from 'react';

import PageContext from '@contexts/PageContext';
import { Layout } from '@components';
import { getBackupImg } from '@helpers/dataExists';
import { ProductPageSection } from '@containers';

const ProductPage = () => {
  const data = useContext(PageContext);
  const { DisplayOptions, DarkMode } = data;

  useEffect(async () => {
    await getBackupImg();
  });

  return (
    <Layout DarkMode={DarkMode}>
      {DisplayOptions?.map((sectionData, index) => (
        <ProductPageSection
          key={`page-section-${index}`}
          data={sectionData}
          productType={data.ProductType}
          DarkMode={DarkMode}
        />
      ))}
    </Layout>
  );
};

export default ProductPage;
